/**
 * Teaser.
 */

const Teaser = ( { teaser } ) => {
	return (
		<a href={ teaser.permalink } className="c-card c-thumbnail">
			{ teaser.thumbnail &&
				<img src={ teaser.thumbnail } />
			}
			<div className="c-thumbnail__content">
				<p class="c-thumbnail__label">
					{ teaser.post_type }
				</p>
				<h3>{ teaser.title }</h3>
				<p>
					{ teaser.excerpt }
				</p>
				<p className="c-button-link u-margin-none">Meer info →</p>
			</div>
			<div class="c-thumbnail__details">
				<p className="c-thumbnail__author">
					{ teaser.author }
				</p>
				<p className="c-thumbnail__date">
					{ teaser.date }
				</p>
			</div>
		</a>
	)
}

export default Teaser;
